import { useCallback } from "react";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestMutation from "@/remoteState/useRestMutation";
import useRestQuery from "@/remoteState/useRestQuery";

export const useContentFeedback = (contentId, skip = false) => {
  return useRestQuery(
    `${MONOLITH_ORIGIN}/api/v3/content-feedback/${contentId}/`,
    { skip },
  );
};

export const usePostContentFeedback = () => {
  const postContentFeedback = useCallback((payload) => {
    const requestParams = {
      method: "POST",
      body: JSON.stringify(payload),
      headers: { "Content-Type": "application/json" },
    };
    return new Request(
      `${MONOLITH_ORIGIN}/api/v3/content-feedback/`,
      requestParams,
    );
  }, []);
  return useRestMutation(postContentFeedback);
};
